var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3285_15708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.97 5.29C19.89 5.11 19.67 4.99 19.5 4.99L11.25 5.02C11.25 5.02 11.2 5.02 11.17 5.02L0.499997 5.05C0.299997 5.05 0.119997 5.17 0.0399968 5.35C-0.0400032 5.53 -3.21865e-06 5.75 0.129997 5.9L9.59 16.17C9.69 16.27 9.82 16.33 9.96 16.33C10.1 16.33 10.24 16.27 10.33 16.17L19.87 5.85C20.01 5.7 20.04 5.49 19.96 5.3L19.97 5.29Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3285_15708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.5c7a1b1bf786c11bd86ab41bd54fa364.svg";
export { ForwardRef as ReactComponent };